import { cfetch } from '@confluence/network';

export type TeamMember = {
	membershipId: {
		memberId: string;
	};
	avatar?: string;
};

export type TeamData = {
	id: string;
	isVerified: boolean;
	largeAvatarImageUrl: string;
	largeHeaderImageUrl?: string;
	description?: string;
	members?: TeamMember[];
};

type TeamDataFromAPI = {
	creatorId: string;
	description: string;
	displayName: string;
	externalReference: {
		id: string;
		source: string;
		syncTeamName: boolean;
	};
	id: string;
	isVerified: boolean;
	largeAvatarImageUrl: string;
	largeHeaderImageUrl: string;
	members: [
		{
			membershipId: {
				memberId: string;
				teamId: string;
			};
			role: string;
			state: string;
		},
	];
	membershipSettings: string;
	organizationId: string;
	smallAvatarImageUrl: string;
	smallHeaderImageUrl: string;
	state: string;
};

export const fetchTeamData = async (siteId: string, teamIds: string[]): Promise<TeamData[]> => {
	const teamsRestApiUrl = `/gateway/api/v4/teams/withMembers/bulk`;

	const response = await cfetch(teamsRestApiUrl, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			siteId,
			teamIds,
		}),
	});

	const body = await response.json();

	return body.teams.map((team: TeamDataFromAPI) => ({
		id: team.id,
		isVerified: team.isVerified,
		largeAvatarImageUrl: team.largeAvatarImageUrl,
		largeHeaderImageUrl: team.largeHeaderImageUrl,
		description: team.description,
		members: team.members.map((member) => ({
			membershipId: member.membershipId,
			avatar: '', // will be set later
		})),
	}));
};
